<template>
	<div>
		<b-collapse
			id="terms"
			v-model="showTerms"
			class="terms"
		>
			<div class="content">
				<h4>Terms and Conditions</h4>
				<p>TopMoving.com (the “Website”) owns the website located at http://www.topmoving.com. By accessing and using the Website you (the “User”) agree to be bound by these terms and conditions (the “Terms”) which govern your access to and use of the Website.</p>

				<h5>Ownership and Use of Content and Intellectual Property Rights</h5>
				<p>All text, data, charts, tables, software, video, music, sound, graphics, photographs, illustrations, artwork, names, logos, trade marks, service marks and other material on the Website (the “Content”) and all rights in it belongs to TopMoving.com, unless otherwise noted or plainly obvious. You may retrieve and display Content from the Website on a computer screen, print individual pages on paper (but not photocopy them) and store such pages in electronic form on disk (but not on any server or other storage device connected to a network) for your personal use. Content may not be copied, reproduced, republished, downloaded, posted, broadcast or transmitted in any other way. You agree not to adapt, alter or create a derivative work from any of the Content on the Website or to use it for any purpose other than for your personal and non-commercial use. All copyright, trade marks, database rights and other intellectual property rights that may exist in this Website and the Content shall remain at all times the property of TopMoving.com. The trade marks, service marks and logos used and displayed on this Website (“Trade Marks”) are registered or unregistered trade marks of TopMoving.com. Nothing on this Website should be construed as granting, by implication or otherwise, any licence or right to use any Trade Mark without written permission from TopMoving.com. The name of TopMoving.com may not be used in any way, including in advertising or publicity pertaining to distribution of Content without the prior written permission of TopMoving.com.</p>

				<h5>Unlawful Use</h5>
				<p>You agree to use this Website only for lawful purposes and in a manner that does not infringe the rights of or restrict or inhibit the use and enjoyment of the Website by any third party. Such restriction or inhibition includes, but is not limited to, conduct which is defamatory, or which may harass, cause distress or inconvenience to any person and the transmission of obscene or offensive content or the disruption of normal flow of dialogue within the Website.</p>

				<h5>Liability</h5>
				<p>The Website and Content is provided “AS IS” and on an “AS AVAILABLE” basis and TopMoving.com does not guarantee the accuracy, timeliness, completeness, performance or fitness for a particular purpose of the Website or any Content. All implied warranties, including but not limited to the implied warranties of satisfactory quality, fitness for a particular purpose, non-infringement, compatibility, security and accuracy are excluded from these Terms to the extent that they may be excluded as a matter of law. In no event will TopMoving.com be liable for any loss including, without limitation, indirect or consequential loss, or any damages arising from loss of use, data or profits, whether in contract, tort or otherwise, arising out of or in connection with the use of this Website. TopMoving.com has tried to ensure that all the Content provided on the Website is correct at the time of publication. The Content is provided on an information basis only and should not be relied upon. No responsibility is accepted by or on behalf of TopMoving.com for any errors, omissions, or misleading Content on the Website or on any websites to which the Website connects. TopMoving.com does not warrant that the Website or Content will be uninterrupted or error free, that any defects will be corrected, or that this Website or the server that makes it available are free of viruses or bugs.</p>

				<h5>Changes to the Terms</h5>
				<p>TopMoving.com reserve the right, at its discretion, to make changes to any parts of the Website or these Terms. When these Terms are amended, TopMoving.com will publish details of the amendments on the Website. Your continued use of the Website is taken as your agreement to be bound by these Terms as amended.</p>

				<h5>Jurisdiction</h5>
				<p>These Terms shall be governed by and construed in accordance with United States Law and subject to the exclusive jurisdiction of the State of Arizona.</p>

				<h5>Severability</h5>
				<p>If these Terms or any part of them should be determined to be illegal, invalid or otherwise unenforceable under the laws of any state or country in which these Terms are intended to be effective, then to the extent that they are so illegal, invalid or unenforceable, they shall in that state or country be treated as severed and deleted from these Terms and the remaining Terms shall survive and remain in full force and effect and continue to be binding and enforceable in that state or country.</p>

				<h5>Events Beyond Our Control</h5>
				<p>TopMoving.com will not be responsible for any breach of these Terms caused by circumstances beyond its reasonable control.</p>

				<h5>Links</h5>
				<p>TopMoving.com may make available third party links, but is not responsible for the availability or content of any third party websites or material you access through this Website.</p>

				<h5>Conflict</h5>
				<p>Should there arise any conflict between these Terms and any other written agreement between you and TopMoving.com then the latter shall prevail.</p>
			</div>
		</b-collapse>

		<b-collapse
			id="privacy"
			v-model="showPrivacy"
			class="privacy"
		>
			<div class="content">
				<h4>Privacy Policy</h4>
				<h5>Personal Information Collection and Use</h5>
				<p>At TopMoving.com, we collect personal information about you, such as your full name, email and telephone number in order to provide you with the moving services you have requested.</p>

				<p>TopMoving.com does not, without your permission, rent, sell, exchange, or otherwise disclose personally identifiable information collected on our site except as described on this privacy policy. Personal information you provide to TopMoving.com is used to service and process your requests. To service your requests, third parties such as moving, storage and auto transport companies – depending on your request – need to be involved. TopMoving.com may also share your personal information with other third parties in order for them to market to you products and services beyond those specifically requested. TopMoving.com does not permit these third parties to share any of the personal information provided to them, which you have previously provided to TopMoving.com.</p>

				<h5>Security</h5>
				<p>TopMoving.com maintains physical, electronic, and procedural safeguards that comply with the law, to guard your non-public personal information.</p>

				<p>We follow generally accepted industry standards to protect the personal information submitted to us, both during transmission and once we receive it. No method of transmission over the Internet, or method of electronic storage, is 100% secure, however. Therefore, while we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.</p>

				<p>If you have any questions about security on our website, you can send email us at support@TopMoving.com.</p>

				<h5>Child Privacy</h5>
				<p>If you are under the age of 13, you should not provide information on our website. We do not collect personal information from any person we known to be a child under the age of 13. If you have knowledge that a child under the age of 13 has submitted any information to us, please email support@TopMoving.com.</p>

				<p>As required by law, such as to comply with a subpoena, or similar legal process when we believe in good faith that disclosure is necessary to protect our rights, protect your safety or the safety of others, investigate fraud, or respond to a government request.</p>

				<h5>Storage of Files</h5>
				<p>As is true of most websites, TopMoving.com also gathers certain information automatically and stores it in log files. This information includes internet protocol (IP) addresses, browser type, internet service provider (ISP), referring/exit pages, operating system, date/time stamp, and clickstream data.</p>

				<p>We use this information, which does not identify individual users, to analyze trends, to administer our site, to track users’ movements around our site and to gather demographic information about our user base as a whole. We do not link this automatically-collected data to personally identifiable information.</p>

				<h5>Cookies</h5>
				<p>A cookie is a small amount of data, which often includes an anonymous unique identifier that is sent to your browser from a website’s computer and stored on your computer’s hard drive. Each time you make a request on our site, a cookie is sent back to our website from your computer. The cookie helps us (i) identify you (ii) personalize your experience on our site; (iii) determine the popularity of certain content or advertisements; (iv) statistically monitor how many people are using our website; (v) as session timers; and (ix) generally facilitate your navigation. For these purposes our cookies are tied to your personal information.</p>

				<p>Your browser is generally set to accept cookies; however, you may set it up so it will not. This action may affect your experience on our site as you may not be able access some areas of the website or use some of the features on the site. A website can send its own cookie to your browser if your browser’s preferences allow it, but (to protect your privacy) your browser only permits a website to access the cookies that website has already sent to you, not the cookies sent to you by other websites.</p>

				<h5>Service Providers</h5>
				<p>We partner with third parties to provide users with moving companies, storage providers, auto transporters and moving supply providers on our site. When a consumer requests any of these services, we will share their name, email address, phone number, and specific location, as necessary, to these third parties so that they may provide the requested service(s).</p>

				<p>When a user comes to our site and requests a quote from our service providers, the user’s personal information is then sent to a limited list of service providers that will be able to assist the user with his/her needs. The user’s personal information may also be sent to one or more additional third parties in order for them to market products and services beyond those specifically requested. The maximum number of companies this information will be sent to is 8. However, the number of companies could be lower depending on how many providers we have available in the state, county, or city that such services have been requested. personal information will be sent with the utmost possible speed upon consumer submission of such information. TopMoving.com will keep a copy of all consumers’ personal information on its data base for the purposes of record keeping and any necessary provision of assistance to consumers or service providers. Once a consumer’s information is received by the service provider, response time is at the complete discretion of the service provider.</p>

				<p>These third parties are prohibited from using your personally identifiable information for any other purpose. If you wish to no longer have your personal information by these third parties to provide you with their services you may email us at support@TopMoving.com.</p>

				<h5>Links to Other Sites</h5>
				<p>This Web site contains links to other sites that are not owned or operated by TopMoving.com. Please be aware that we, TopMoving.com, are not responsible for the privacy practices of such other sites.</p>

				<p>We encourage you to be aware of when you leave our site and to read the privacy statements of each and every Web site that collects personally identifiable information.</p>

				<p>This privacy statement applies only to information collected by this Web site.</p>

				<h5>Changes to This Policy</h5>
				<p>If this privacy policy is changed at any time, we will make every effort to note those changes in the privacy statement, and other locations we deem appropriate so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we disclose it.</p>

				<p>We reserve the right to modify this privacy statement at any time, so please review it frequently. If we make material changes to this policy, we will notify you here, by email, or by means of a notice on our home page.</p>

				<h5>Contact Information</h5>
				<p>If you have any questions or concerns regarding this policy, please contact us by emailing support@TopMoving.com. We make every effort to respond within one business week.</p>

				TopMoving.com<br />
				support@TopMoving.com
			</div>
		</b-collapse>
		<div
			class="footer row"
		>
			<div class="col-md-6 text-left">
				<p>&copy; 1998 TopMoving - iRelocation Network, Inc.</p>
				<p>335 N. Austin Dr, Chandler, AZ 85226</p>
			</div>
			<div
				v-show="$route.name == 'Pickup' || $route.name == 'notfound'"
				class="col-md-6 text-right"
			>
				<ul>
					<li><a @click="toggleTerms()">Terms</a></li>
					<li><a href="/sitemap">Sitemap</a></li>
					<li><a @click="togglePrivacy()">Privacy Policy</a></li>
					<li><a @click="joinNetwork = true;">Join Our Network</a></li>
				</ul>
			</div>
		</div>

		<div
			v-if="joinNetwork || thankyou"
			id="join-network"
		>
			<div
				v-if="joinNetwork"
				class="join-modal"
			>
				<span
					class="join-close"
					@click="joinNetwork = false;"
				>
					x
				</span>
				<h1 class="h1">
					Join Our Network
				</h1>
				<p>Share your contact info to start receiving leads today, or so we can help answer your questions.</p>
				<form
					class="join-form"
					method="post"
					@submit.prevent="submitJoin"
				>
					<div class="jf-item">
						<label>Your Company Name*</label>
						<input
							v-model="join_info.company"
							type="text"
							name="company"
							placeholder="Acme Co."
							required
						/>
					</div>
					<div class="jf-item">
						<label>Your Full Name*</label>
						<input
							v-model="join_info.name"
							type="text"
							name="name"
							placeholder="Douglas Adams"
							required
						/>
					</div>
					<div class="jf-item">
						<label>Your Phone Number*</label>
						<masked-input
							v-model="join_info.phone"
							mask="(###) ### - ####"
							type="tel"
							name="phone"
							placeholder="(480) 785 - 7400"
							required
						/>
					</div>
					<div class="jf-item">
						<label>Your Email Address</label>
						<input
							v-model="join_info.email"
							type="text"
							name="email"
							placeholder="you@company.com"
						/>
					</div>
					<button type="submit">
						Get Leads
					</button>
				</form>
			</div>
			<div
				v-if="thankyou"
				class="join-modal thankyou"
			>
				<span
					class="join-close"
					@click="thankyou = false;"
				>
					x
				</span>
				<img
					src="/static/images/Group.png"
					width="128"
				/>
				<h1 class="h1">
					Thank You
				</h1>
				<p>We’ve received your request for more info. We’ll get back to you as quickly as possible. </p>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';

import bCollapse from 'bootstrap-vue/es/components/collapse/collapse';

import { TheMask } from 'vue-the-mask';

export default {
	name: 'AppFooter',
	components: {
		'b-collapse': bCollapse,
		'masked-input': TheMask,
	},
	data() {
		return {
			join_info: {},
			joinNetwork: false,
			showTerms: false,
			showPrivacy: false,
			thankyou: false,
		};
	},
	methods: {
		toggleTerms: function() {
			this.showPrivacy = false;
			this.showTerms = !this.showTerms;
		},
		togglePrivacy: function() {
			this.showTerms = false;
			this.showPrivacy = !this.showPrivacy;
		},
		submitJoin: function(event) {
			event.preventDefault();

			if (this.join_info.phone) {
				this.join_info.phone = this.join_info.phone
					.match(/[0-9]{1,}/g)
					.join('');
			}

			const form_data = new FormData();
			const keys = Object.keys(this.join_info);

			for (let i = 0; i < keys.length; i++) {
				form_data.append(keys[i], this.join_info[keys[i]]);
			}
			const vm = this;

			axios
				.post('https://formkeep.com/f/9e17c815754a', form_data)
				.then(() => {
					vm.joinNetwork = false;
					vm.thankyou = true;
					setTimeout(() => {
						vm.thankyou = false;
					}, 30000);
				})
				.catch(err => {
					this.$log.error('Could not post Join data', err);
				});
		},
	},
};
</script>

<style scoped lang="scss">
.footer {
	margin: 0 !important;
	padding: 10px 0 !important;
	background: white;
	font-size: 12px;
	color: rgba(69, 71, 89, 0.49);

	p {
		margin: 0;
	}

	ul {
		list-style-type: none;
		margin: 0;
		padding: 0;

		li {
			display: inline-block;
			padding: 0 10px;
			border-right: 1px solid;
		}

		li:last-child {
			border-right: none;
			padding-right: 0;
		}

		a {
			cursor: pointer;
			color: darkgray;
		}
		a:hover {
			text-decoration: underline !important;
		}
	}
}

.terms,
.privacy {
	background: white;
	width: 100%;

	.content {
		text-align: left;
		width: 100%;
		max-width: 1000px;
		margin: 0 auto;
		padding: 10px;
		border-radius: 4px;
		background: #d0e8f4;
	}

	h4 {
		font-size: 1.2rem;
	}

	h5 {
		font-size: 0.9rem;
	}
}

#join-network,
#thankyou {
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background: rgba(0, 0, 0, 0.6);
	z-index: 10000000;
	display: flex;
	justify-content: center;
	align-items: center;

	.join-modal {
		background: #ffffff;
		border-radius: 10px;
		width: 400px;
		min-height: 500px;
		/*-webkit-box-shadow: -1px 0px 8px 3px rgba(204,204,204,1);*/
		/*-moz-box-shadow: -1px 0px 8px 3px rgba(204,204,204,1);*/
		/*box-shadow: -1px 0px 8px 3px rgba(204,204,204,1);*/
		display: flex;
		flex-direction: column;
		position: relative;
		align-items: center;

		.join-close {
			position: absolute;
			top: 10px;
			right: 25px;
			color: #8d9db7;
			font-size: 1.5rem;
			cursor: pointer;
		}

		.h1 {
			font-size: 1.6rem;
			margin-top: 50px;
			color: #043a6b;
			// font-family: 'Open Sans', sans-serif;
			font-weight: 600;
		}

		p {
			text-align: center;
			color: #8d9db7;
			// font-family: 'Open Sans', sans-serif;
			font-size: 1rem;
			line-height: 1rem;
			width: 80%;
			margin-top: 5px;
		}

		.join-form {
			width: 75%;

			button {
				margin: 2rem 0 2.5rem;
				display: block;
				width: 100%;
				background: #7eb846;
				border-radius: 25px;
				border: none;
				padding: 4px 15px;
				color: #ffffff;
				font-size: 1.5rem;
			}

			button:focus {
				outline: none;
			}

			button:hover {
				background: #7eb846 !important;
			}
		}

		.jf-item {
			font-size: 1rem;
			margin-bottom: 0.5rem;

			label {
				display: block;
				text-align: left;
				font-size: 1rem;
				margin-bottom: 0.4rem;
				color: #043a6b;
				font-weight: 600;
			}

			input {
				width: 100%;
				border: 1px solid lighten(#8d9db7, 25%);
				border-radius: 5px;
				padding: 7px 15px;
			}

			::-moz-placeholder {
				color: #819cb5;
			}

			::-webkit-input-placeholder {
				color: #819cb5;
			}

			:-ms-input-placeholder {
				color: #819cb5;
			}

			::placeholder {
				color: #819cb5;
			}
		}
	}

	.thankyou {
		justify-content: center;

		.h1 {
			color: #043a6b;
			font-size: 1.6rem;
			font-weight: 600;
			margin: 35px 0 25px;
		}

		p {
			font-size: 1rem;
			color: #043a6b;
		}
	}
}
</style>
